import { doAjax } from './helper'
import { loadAlreadyCustomizedOptions } from './interior-general-logic'
import { loadBasicColorSeatLayers } from './screen-seat--components-logic'

function initSummaryAndGeneratePDF() {
	const frontSeatModel = document.querySelector("input[name=frontseatmodel]").value;
	const backSeatModel = document.querySelector("input[name=backseatmodel]").value;
	const skipQ7PdfSeatLayers =
		aeo['configuration']['YN1_Q7Q9'] === true
		|| aeo['configuration']['YN2_Q7Q9'] === true
		|| aeo['configuration']['97R_Q7Q9'] === true
		|| aeo['configuration']['FZ8_Q7Q9'] === true
		|| aeo['configuration']['FZ9_Q7Q9'] === true
		|| aeo['configuration']['0TF_Q7Q9'] === true

	// Nur YN1/YN2 nutzen eine einzelne, statisch gerenderte _naht.png je Sitz → JS-Sitzkomponenten
	// (mehrere, einzeln einfärbbare Nahtteile) überspringen. Lederpakete (97R/0TF/FZ8/FZ9) brauchen
	// die JS-Komponentennähte, daher hier NICHT überspringen.
	const skipQ7PdfSeatComponentImages =
		aeo['configuration']['YN1_Q7Q9'] === true
		|| aeo['configuration']['YN2_Q7Q9'] === true

	if (!skipQ7PdfSeatLayers) {
		loadBasicColorSeatLayers(frontSeatModel, backSeatModel)
	}

	const loadOptions = skipQ7PdfSeatComponentImages ? { skipSeatImages: true } : {}
	loadAlreadyCustomizedOptions(() => {}, loadOptions)

	document.getElementById('navigation-submit-btn')?.addEventListener('click', () => {
		let summaryButton = document.getElementById('display-controller')
		if (summaryButton.classList.contains('summary') == false) {
			summaryButton.classList.add('summary')
		}
	})

	document.getElementById('generate-pdf')?.addEventListener('click', () => {
		let summaryButton = document.getElementById('display-controller')
		if (summaryButton.classList.contains('summary')) {
			summaryButton.classList.remove('summary')
		}
	})
}

const initValidation = () => {
	var sidebar = document.querySelector('.sidebar-content')
	var pdf = document.querySelector('#generate-pdf')
	var textfields = document.querySelectorAll('.aui-textfield[required]')
	pdf?.addEventListener('click', (e) => {
		for (var textfield of textfields) {
			let input = textfield.querySelector('.aui-textfield__input').value
			if (input.trim() == null || input.trim() == '' || input === ' ') {
				e.preventDefault()
				textfield.classList.add('is-invalid')
				sidebar.scrollTop = 0
				window.scrollTo(0, 0)
			}
			else {
				textfield.classList.remove('is-invalid')
			}
		}
	})
}

const saveMetaOnChange = () => {
	document.querySelectorAll('.aui-textfield__input')?.forEach((field) => {
		field.addEventListener('change', () => {
			doAjax({
				'saveMeta': true,
				'field': field.name,
				'value': field.value
			})
		})
	})
}

export { initSummaryAndGeneratePDF, initValidation, saveMetaOnChange }